<template>
  <div class="ips_list col-md-12" >
    <div
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
            <span
                class="mdi"
                :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
                @click="toggleFiltersState"
            />
      <span class="main_fiters_toggler_text">
              {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
            </span>
    </div>

    <div class="header card_add form-group" :class="filters_state === true ? 'shown' : 'hidden'">
      <span
        class="btn btn-success btn-fill mdi mdi-plus-circle-outline"
        @click.prevent="new_IPS({})"
      >
          {{ translate('ip_profile.add') }}
      </span>
    </div>

    <div class="row response_table content" >
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col" style="width: 40px">
              ID
            </th>
            <th
                class="pointer"
                @click="change_filter('server')"
                :class="{ selected: filter_type === 'server' }"
                scope="col"
            >
              {{ translate('ip_profile.server') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('name')"
                :class="{ selected: filter_type === 'name' }"
                scope="col"
            >
              {{ translate('ip_profile.name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('short_name')"
                :class="{ selected: filter_type === 'short_name' }"
                scope="col"
            >
              {{ translate('ip_profile.name_short') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('ip')"
                :class="{ selected: filter_type === 'ip' }"
                scope="col"
            >
              IP
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('ports')"
                :class="{ selected: filter_type === 'ports' }"
                scope="col"
            >
              {{ translate('ip_profile.ports') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('by_ports')"
                :class="{ selected: filter_type === 'by_ports' }"
                scope="col"
            >
              {{ translate('ip_profile.by_ports') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th scope="col">
              {{ translate('min') }}
            </th>
            <th scope="col">
              {{ translate('max') }}
            </th>
            <th
                class="pointer"
                @click="change_filter('devices_count')"
                :class="{ selected: filter_type === 'devices_count' }"
                scope="col"
            >
              {{ translate('ip_profile.devices_count') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <router-link
            v-for="(ip,key) in ip_list"
            :key="key"
            :to="'/ip_address/' + ip.id"
            class="ip_item"
          >
            <tr  >
              <td
                  data-label="ID"
                  style="width: 40px"
              >
                {{ ip.id }}
              </td>
              <td :data-label="translate('ip_profile.server')" @click.stop="">
                <router-link :to="{path: '/server/' + ip.server_id}" class="link">
                  <span>{{ get_server_name(ip.server_id) }}</span>
                </router-link>
              </td>
              <td :data-label="translate('ip_profile.name')">
                {{ ip.name }}
              </td>
              <td :data-label="translate('ip_profile.name_short')">
                {{ ip.short_name }}
              </td>
              <td data-label="IP">
                {{ ip.ip }}
              </td>
              <td :data-label="translate('ip_profile.ports')">
                {{ ip.ports }}
              </td>
              <td :data-label="translate('ip_profile.by_ports')">
                {{ ip.by_ports }}
              </td>
              <td :data-label="translate('min')">
                {{ ip.min }}
              </td>
              <td :data-label="translate('max')">
                {{ ip.max }}
              </td>
              <td :data-label="translate('ip_profile.devices_count')">
                {{ ip.devices_count }}
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EditIPS from './Modal/EditIP-address.vue'

export default {
  name: 'List',
  components: {},
  data() {
    return {
      ips: [],
      servers: [],
      filter_asc: "asc",
      filter_type: "",
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },
  created() {
    this.get_ips()
  },

  computed: {
    server_list() {
      let server_list = []
      for (let server of this.$store.getters.getServerList) {
        server_list.push({id: server.id, label: server.name})
      }
      return server_list
    },
    ip_list(){
      let ip_list = this.ips.map((item) => {
        return {...item, server: this.check_server(item.server_id)}
      })
      return ip_list.sort(this.compareNumbers);
    },
  },

  methods: {
    get_server_name(server_id){
      let serv = this.$store.getters.getServerList.find((server) => {
        if (server.id === server_id) return server
      })
      return serv ? serv.name : ""
    },
    check_server(server_id) {
      if (server_id !== null) {
        const server_info = this.servers.find((server) =>{
          if (server.id === server_id) return server
        })
        return server_info ? server_info.name + '(' + server_info.ip + ')' : ''
      }
      return ''
    },
    get_ips() {
      this.$http.v1.getIPSList((response) => {
        this.ips = response.data
      })
    },
    new_IPS(val) {
      let t = this.$createElement(EditIPS, {
        props: {
          ips: val,
          server_list: this.server_list
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          },
          update: (val) => {
            this.update(val)
          }
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {height: 'auto', name: 'dynamic-modal'})
    },
    update(val) {
      if (val.id) {
        this.$http.v1.updateIPS(val.id, val, () => {
          this.global_notify('info', this.translate('profile_saved'))
          this.$modal.hide('dynamic-modal')
          this.get_ips()
        })
      } else {
        this.$http.v1.createIPS(val, () => {
          this.global_notify('info', this.translate('profile_saved'))
          this.$modal.hide('dynamic-modal')
          this.get_ips()
        })
      }
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>
.ips_list{
  height: 100%;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  .ip_item{
    color: #252422;
    tr{
      &:hover{
        background-color: #eee;
      }
    }
  }

  .header{
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    .manage_btn{
      margin: 0;
    }
  }
  .content{
    flex: 11;
    padding: 0;
  }
}

</style>
